import mapActions from './mapActions';

export default mapActions('employee_types', {
	fetchAll_url: () => '/api/employees/types',
});
